import React from 'react';

import Loadable from '@townsquare/loadable';
import { LoadingState } from '@townsquare/loading-state';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { kudosDirectoryRoute } from '@townsquare/routes/kudos-directory-view';

import { kudosDirectoryResource } from './resources/kudosDirectoryResource';

const KudosDirectoryLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "KudosDirectory" */ './KudosDirectoryWithResource'),
	loading: () => <LoadingState />,
	delay: 0,
});

kudosDirectoryRoute.component = KudosDirectoryLoadable;
kudosDirectoryRoute.resources = [kudosDirectoryResource];

export const kudosDirectoryRouterRoute: GlobalHomePageRoute = kudosDirectoryRoute;
